<template>
  <div class="case-content">
    <div class="case-img">
      <slot name="case-img"></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: 'fullWidthPicture',
}
</script>

<style lang="scss" scoped>
.case-img{
  img{
    width: 100%;
    margin-top: layout-val-8(6);
    margin-bottom: layout-val-8(6);
  }
}

</style>